const { EnumType } = require('json-to-graphql-query');

/**
 * Return filtered attributes by filterText.
 */
const filterAttributes = (attributes, filterText) => {
    if (filterText) {
        filterText = filterText.trim().toLocaleLowerCase();
        if (filterText.length > 0) {
            attributes = attributes.filter((a) => {
                if (!a.label) { return false; }

                const labelPath = (a.path || []).map((p) => p.label).join('>');
                if (!a.label.toLocaleLowerCase().includes(filterText)
                    && !labelPath.toLocaleLowerCase().includes(filterText)) {
                    return false;
                }
                return true;
            });
        }
    }
    return attributes;
};

/**
 * Return dot path of values that represents the attribute path.
 */
const attributePathToString = (attribute) => {
    let path = '';
    if (!attribute) { return path; }

    if (attribute.path) {
        path = attribute.path.map((p) => p.value).join('.');
        if (path && attribute.value) {
            path += '.';
        }
    }
    return path + (attribute.value || '');
};

const defaultFields = { id: true };
/**
 * The token used as a placeholder to replace with new EnumType().
 */
const enumValueToken = '__enumValue';

/**
 * Navigate the object hierarchy and replace { __enumValue: value } with new EnumType(value).  This
 * allows systems that don't have JS access to json-to-graphql-query (such as dotnet) to be able to
 * express filters using enum values.
 * @param obj The object to look for replacement of __enumValue token.
 */
const restoreEnumType = obj => {
    if (!obj) {
        return;
    }

    for (const property in obj) {
        const val = obj[property];
        if (Object.prototype.hasOwnProperty.call(obj, property) && val != null) {
            if (val.constructor === Object && Object.prototype.hasOwnProperty.call(val, enumValueToken)) {
                const enumValue = val[enumValueToken];
                obj[property] = new EnumType(enumValue);
            } else if (val.constructor === Object) {
                restoreEnumType(val);
            } else if (val.constructor === Array) {
                for (const i of val) {
                    restoreEnumType(i);
                }
            }
        }
    }
};

/**
 * Builds the JSON as an object that can be supplied to jsonToGraphQLQuery for downstream execution
 * by the Data Access EEDM endpoint.
 * @param queryName The properly-cased GraphQL query name to execute. Ex: constituentPersons.
 * @param jsonToGraphQLFilter The json-to-graphql-query filter output from the query builder.
 * @param fields The optional fields to retrieve in json-to-graphQL format.  Ex: { id: true, gender: true } Default: { id: true }
 * @param ids The optional list of IDs to further refine the query.
 * @param pretty True if output should be made pretty.
 * @returns The resulting JSON object to be supplied to jsonToGraphQLQuery.
 */
const jsonToGraphFilterToJsonToGraphObject = (queryName, jsonToGraphQLFilter, fields = defaultFields, ids = []) => {
    if (!queryName) {
        throw Error('queryName is required.');
    }
    // translate { _enumValue: value } placeholder into new EnumType(value)
    restoreEnumType(jsonToGraphQLFilter);

    const graphQL = {};
    const query = graphQL[queryName] = {
        __args: {
            filter: {},
        },
        edges: {
            node: {},
        },
    };

    let args = query.__args;
    // build filter
    if (jsonToGraphQLFilter) {
        args.filter = jsonToGraphQLFilter;
    }
    // build id filter as an IN clause
    if (ids && ids.length) {
        args.filter = { ...args.filter, id: { IN: ids } };
    }
    // build fields to return
    query.edges.node = fields;

    return graphQL;
};

module.exports = {
    attributePathToString,
    filterAttributes,
    jsonToGraphFilterToJsonToGraphObject,
    restoreEnumType,
};
